module.exports = __webpack_public_path__ + "static/media/totul-pentru-educatie-logo-v1.7638385a.png";